import {useQuery} from '@tanstack/react-query'
import {useEffect} from 'react'
import api, {GetCameraParams} from 'src/services/api'
import {QueryKeyEnum} from 'src/utilities/enums/QueryKeyEnum'

type Props = {
  cameraId: number
  onError?: (error: unknown) => void
  params?: GetCameraParams
  enabled?: boolean
}

export default function useSingleCamera({cameraId, params, onError, enabled = true}: Props) {
  const query = useQuery({
    enabled,
    queryKey: [QueryKeyEnum.CAMERA, cameraId, params],
    initialData: null,
    queryFn: async () => (await api.camera.getById(cameraId, params)).data.data,
  })

  useEffect(() => {
    if (query.isError) onError?.(query.error)
  }, [query.error])

  return query
}
